
import { NavigatorWithKeyboard } from './types';

/**
 * Patches EditorJS to handle keyboard layout detection errors
 */
export const patchEditorJS = () => {
  const navigator = window.navigator as NavigatorWithKeyboard;
  
  if (navigator.keyboard && typeof navigator.keyboard.getLayoutMap === 'function') {
    const originalGetLayoutMap = navigator.keyboard.getLayoutMap.bind(navigator.keyboard);
    
    Object.defineProperty(navigator.keyboard, 'getLayoutMap', {
      value: async function() {
        try {
          return await originalGetLayoutMap();
        } catch (err) {
          console.warn('Suppressed keyboard layout detection error:', err);
          return new Map();
        }
      },
      configurable: true
    });
  }
};

/**
 * Calculates word count and reading time from editor blocks
 */
export const calculateReadingStats = (blocks: any[]) => {
  let totalWords = 0;
  
  if (blocks && Array.isArray(blocks)) {
    blocks.forEach((block: any) => {
      if (block.type === 'paragraph' || block.type === 'header' || block.type === 'quote') {
        const text = block.data?.text?.replace(/<[^>]*>/g, '') || '';
        const words = text.split(/\s+/).filter(word => word.length > 0);
        totalWords += words.length;
      } else if (block.type === 'list' && Array.isArray(block.data?.items)) {
        block.data.items.forEach((item: string) => {
          const text = item.replace(/<[^>]*>/g, '') || '';
          const words = text.split(/\s+/).filter(word => word.length > 0);
          totalWords += words.length;
        });
      }
    });
  }
  
  const readingTime = Math.ceil(totalWords / 225); // Average reading speed
  
  return { wordCount: totalWords, readingTime };
};
